"use client";
import { useEffect, useRef, useCallback } from "react";
import useLiveSupport from "./useLiveSupport";
import useCallStart from "@/app/lib/features/callStart/callStart.hook";

const useAiCall = () => {
  const { data, isLoading, isError, isSuccess, fetchCallStart, clearCallStart } =
    useCallStart();

  const pendingOpenRef = useRef(false);

  const sipConfig = data ?? null;
  const liveSupportEnabled = isSuccess && sipConfig !== null;

  const liveSupport = useLiveSupport(
    sipConfig ?? {
      wssServer: "",
      uri: "",
      username: "",
      password: "",
      target: "",
      iceServers: [],
    },
  );

  // Config fetch tamamlanınca bekleyen open isteğini gerçekleştir
  useEffect(() => {
    if (isSuccess && sipConfig && pendingOpenRef.current) {
      pendingOpenRef.current = false;
      liveSupport.open();
    }
  }, [isSuccess, sipConfig, liveSupport]);

  const open = useCallback(() => {
    // Her açılışta yeniden fetch et — user params (ad, soyad, telefon) göndermek için
    pendingOpenRef.current = true;
    fetchCallStart();
  }, [fetchCallStart]);

  const close = useCallback(() => {
    pendingOpenRef.current = false;
    liveSupport.close();
    clearCallStart();
  }, [liveSupport, clearCallStart]);

  return {
    ...liveSupport,
    open,
    close,
    isLoadingConfig: isLoading,
    isConfigError: isError,
    isConfigReady: liveSupportEnabled,
  };
};

export default useAiCall;